import { Edit, NumberInput, RadioButtonGroupInput, SimpleForm, TextInput, required } from 'react-admin';
import { Grid } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import CommonEdit from '@/components/common/Edit';
import FixedRouteForm from './FixedRouteForm';
import { singleProp } from '@/interface/dataInterface';
import axios from 'axios';
import { BASE_URL } from '@/config';

const FixedRouteEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState({
        price: '', currency: ''
    })
    const [otherData, setOtherData] = useState<{
        origin: { text: string; lat: number; lng: number } | null,
        destination: { text: string; lat: number; lng: number } | null
    }>({
        origin: null,
        destination: null
    })

    const handleOtherData = (data: any, id: string) => {
        setOtherData(prev => {
            return {
                ...prev,
                [id]: data
            }
        })
    }

    useEffect(() => {
        if (!prop) return;
        const unsub = async () => {
            const {data} = await axios.get(`${BASE_URL}/fixed-routes/${prop}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                }
            })

            const {price, currency, origin, origin_lat, origin_lon, destination, destination_lat, destination_lon} = data

            setFormProp({price, currency})
            setOtherData({
                origin: {text: origin, lat: origin_lat, lng: origin_lon},
                destination: {text: destination, lat: destination_lat, lng: destination_lon}
            })
        }

        unsub()
    }, [prop])

    return (
        <CommonEdit id={prop} title='Edit' resource='fixed-routes' data={{
            ...formProp,
            origin: otherData?.origin?.text,
            origin_lat: otherData?.origin?.lat,
            origin_lon: otherData?.origin?.lng,
            destination: otherData?.destination?.text,
            destination_lat: otherData?.destination?.lat,
            destination_lon: otherData?.destination?.lng,
        }} responseMessage={`Route ${prop} edited`}>
            <FixedRouteForm formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={handleOtherData}/>
        </CommonEdit>
    );
};

export default FixedRouteEdit;
